/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/state-in-constructor */
/* eslint-disable react/static-property-placement */
import React from 'react';
import PropsTypes from 'prop-types';
import clsx from 'clsx';
import Icon from '@material-ui/core/Icon';
import withStyles from '@material-ui/core/styles/withStyles';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import Menu from '@material-ui/core/Menu/Menu';
import customClassName from '@configuratorware/configurator-frontendgui/App/Utils/customClassName';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import Popper from '@material-ui/core/Popper';
import AnalyticsWrapper from '@configuratorware/configurator-frontendgui/App/Shared/Components/Analytics/AnalyticsWrapper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import MenuList from '@material-ui/core/MenuList';
import {
  DownloadIcon, MailIcon, SaveIcon, LoadIcon,
} from '../../../../Icons';

const styles = (theme) => ({
  muiPaper: {
    zIndex: 100,
    '& .MuiPaper-root': {
      background: theme.palette.primary.dark,
      borderRadius: 100,
      boxShadow: 'none',

    },
    '& .MuiList-root': {
      borderRadius: 100,
      padding: 0,
      '&:hover': {
        background: '#959595',
        color: theme.palette.primary.hoverText,
      },
      '&:focus,&:active': {
        background: '#585858',
        color: theme.palette.primary.pressedText,
      },
    },
    '& .MuiMenuItem-root': {
      color: theme.palette.primary.lightText,
      fontWeight: 'bold',
      fontSize: 14,
      '&:hover,&:active,&:focus': {
        background: 'transparent',
        cursor: 'pointer',
      },
    },
  },
  iconHover: {
    margin: 0,
    textAlign: 'center',
    verticalAlign: 'middle',
    borderRadius: '100px',
    '&:hover': {
      cursor: 'pointer',
    },
    '& > span': {
      lineHeight: '24px',
      width: '24px',
      height: '24px',

    },
  },
  iconHoverActive: {
    background: '#959595',
    '& > span': {
      color: theme.palette.primary.hoverText,
    },
  },
  root: {
    whiteSpace: 'nowrap',
  },
});

class ToolbarList extends React.Component {
    static propTypes = {
      classes: PropsTypes.object,
      tools: PropsTypes.array,
    };

    state = {
      anchorEl: null,
      openMenuId: null,
    };

    handleClick = (event) => {
      this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => {
      this.setState({ openMenuId: null, anchorEl: null });
    };

    showMenu = (event, key) => {
      this.setState({ openMenuId: key, anchorEl: event.currentTarget });
    }

    // DownloadIcon, MailIcon, SaveIcon, LoadIcon,
    getIcon = (tool) => {
      /* <Icon
                      title={tool.title && t(tool.title)}
                      key={tool.key}
                    >
                      {tool.identifier}
                    </Icon> */
      let Component = Icon;
      // eslint-disable-next-line default-case
      switch (tool.key) {
        case 'load': {
          Component = LoadIcon;
          break;
        }
        case 'save': {
          Component = SaveIcon;
          break;
        }
        case 'mail': {
          Component = MailIcon;
          break;
        }
        case 'picture_as_pdf': {
          Component = DownloadIcon;
          break;
        }
      }
      return (
        <Component
          title={tool.title && t(tool.title)}
          key={tool.key}
        >
          {tool.identifier}
        </Component>
      );
    }

    render() {
      const { classes, tools } = this.props;
      const { anchorEl } = this.state;
      return (
        <div className={clsx(classes.root, customClassName('tools'), 'ToolbarList')}>

          {tools && (
            tools.map((tool) => (

              <AnalyticsWrapper key={tool.key} targetId={tool.key}>
                <>
                  {this.state.openMenuId === tool.key
                && (
                  <Popper
                    className={classes.muiPaper}
                    placement="top-start"
                    modifiers={{

                      offset: {
                        offset: '0, 10',
                      },
                    }}
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    transition
                    disablePortal
                  >
                    {({ TransitionProps }) => (
                      <Grow
                        {...TransitionProps}

                      >
                        <Paper>
                          <ClickAwayListener onClickAway={this.handleClose}>
                            <MenuList id="menu-list-grow">
                              { /*   <Menu
                          className={classes.muiPaper}
                          anchorEl={anchorEl}
                          keepMounted
                          open={Boolean(anchorEl)}
                          getContentAnchorEl={null}
                          onClose={this.handleClose}
                          anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                          }}
                          transformOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                          }}
                          PaperProps={{
                            style: {
                              marginTop: '-10px',
                            },
                          }}
                        ></Menu> */}
                              <MenuItem onClick={tool.function}>{t(tool.title)}</MenuItem>
                            </MenuList>
                          </ClickAwayListener>
                        </Paper>
                      </Grow>
                    )}
                  </Popper>
                )}
                  <div
                    className={`${classes.iconHover} ${(this.state.openMenuId === tool.key) && classes.iconHoverActive} `}
                    onClick={(e) => {
                      console.log(e, this.state.openMenuId, tool.key);
                      if (this.state.openMenuId === tool.key) this.handleClose();
                      else this.showMenu(e, tool.key);
                    }}
                  >
                    {this.getIcon(tool)}

                  </div>
                </>
              </AnalyticsWrapper>

            ))
          )}
        </div>
      );
    }
}

export default withStyles(styles, { name: 'ToolbarList' })(ToolbarList);
